import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/xhef.actions';

import Fab from '@material-ui/core/Fab';
import Snackbar from '../../labels/Snackbar';
import Grid from '@material-ui/core/Grid';
import Timelapse from '@material-ui/icons/Timelapse';

import correct_bg from '../../../images/progress.png';
import warning_bg from '../../../images/warning.png';
import error_bg from '../../../images/error.1.png';

import { HideIcon, AddIcon } from '../../../images/icons/WrapSvg';
import { percentage, timeDiference, formatDateTime, minutosHHMM } from '../../../functions/time';

// eslint-disable-next-line
import style from './_styles.css';


class Available extends React.Component {
    state = {};

    static getDerivedStateFromProps(props, state) {
        const { xef, tab } = props;

        const data =
            xef && xef.producciones
                ? xef.producciones.filter(
                    (f) =>
                        f.cerrada === null &&
                        (tab === 0 || f.estacion === tab) &&
                        f.produciendo !== null &&
                        f.disponible > 0 &&
                        f.finproduccion,
                )
                : [];
        const horaventa = xef && xef.horaventa ? xef.horaventa : {};
        const productos = xef && xef.productos ? xef.productos : [];
        const productosStock = xef && xef.productosStock ? xef.productosStock : [];
        if (data !== state.data || horaventa !== state.horaventa || productosStock !== state.productosStock) {
            state.data = data;
            state.horaventa = horaventa;
            state.productosStock = productosStock;
            const temp = productos.filter((f) => (tab === 0 || f.nombreEstacion === tab))
                .map((item) => {
                    const stock = productosStock.find(f => f.idProducto === item.id);
                    const units = data.filter((i) => i.idProducto === item.id);
                    if (units) {
                        const valid = units.filter((i) => i.caducidad > props.xef_reference_time);
                        item.units = units;
                        if (valid) {
                            item.total = valid.length > 0
                                ? valid.reduce((total, item) => { total += item.disponible; return total; }, 0)
                                : 0;
                        }
                    }
                    if (stock) {
                        item.idProducto = stock.idProducto;
                        item.prevision = stock.prevision;
                        item.previsionMinutos = stock.previsionMinutos;
                        item.stock = stock.stock;
                        item.tiempoRotura = stock.tiempoRotura;
                        item.horaRotura = stock.horaRotura;
                    }
                    return item;
                });

            state.groupByType = temp.sort((a, b) => a.idProducto > b.idProducto
                ? 1
                : -1
            );
            return state;
        }
        return null;
    }

    handleClick = () => {
        this.props.hide();
    };

    render() {
        const { groupByType, horaventa, error } = this.state;
        const { open, producciondetenida } = this.props;
        console.log(producciondetenida);
        const Item = (group) => {
            const style = {
                backgroundSize: '96px auto',
                backgroundRepeat: 'repeat-y',
                backgroundImage: 'url(' + group.foto + ')',
                backgroundPositionY: 'center',
                height: 42,
                paddingLeft: 100,
                borderBottom: '1px #d7dfe6 solid',
            };
            return (
                <div key={randomstring()} className="flex_auto_column margin_bottom_12">
                    <div
                        className="flex_auto_row c_slate align_center border-available"
                        style={style}
                    >
                        <span className="flex_full_row padding_left_6  barlowsemicondensed_bold ">
                            {group.nombre}
                        </span>

                        <div className="flex_auto_row align_center xhef_available_media ">
                            <span className="flex_auto_row barlowsemicondensed_bold c_bluish">
                                {group.prevision}
                            </span>
                            <span className="flex_auto_row margin_left_6 margin_right_12 barlowsemicondensed_bold_small c_slate">
                                {minutosHHMM(group.previsionMinutos)}
                            </span>
                            <div className={"flex_auto_row barlowsemicondensed_bold margin_right_6 " + (group.stock > 0 ? 'c_purple' : 'c_lipstick')} >
                                {group.stock}
                            </div>
                            {!producciondetenida &&
                                <div className="flex_auto_row center barlowsemicondensed_bold_small c_golden_yellow nowrap margin_right_6">
                                    {timeDiference(this.props.xef_reference_time, group.horaRotura)}
                                </div>
                            }
                        </div>
                    </div>
                    <div className="flex_auto_column">
                        <Grid container className={'flex_grow_1 wrapper'}>
                            {group.units &&
                                group.units
                                    .sort((a, b) => (a.caducidad > b.caducidad ? 1 : -1))
                                    .map((u) => (
                                        <Grid
                                            key={randomstring()}
                                            item
                                            xs={12}
                                            sm={4}
                                            className="flex_full_row align_center pastilla c_dark_grey_blue hand"
                                            onClick={() =>
                                                this.props.handleOpenDecrease('decrease', u)
                                            }
                                        >
                                            <div
                                                className="flex_full_column "
                                                style={{
                                                    backgroundSize:
                                                        percentage(
                                                            u.caducidad,
                                                            this.props.xef_reference_time,
                                                            u.finproduccion,
                                                        ) + '% auto',
                                                    backgroundRepeat: 'repeat-y',
                                                    backgroundImage:
                                                        'url(' +
                                                        (u.caducidad < this.props.xef_reference_time
                                                            ? error_bg
                                                            : this.props.xef_reference_time >
                                                                u.avisocaducidad
                                                                ? warning_bg
                                                                : correct_bg) +
                                                        ')',
                                                    backgroundPositionY: 'center',
                                                }}
                                            >
                                                <div className="flex_auto_row barlowsemicondensed_bold">
                                                    {u.disponible + '/' + u.nombre}
                                                </div>
                                                <div className="flex_auto_row padding_top_6">
                                                    <div className="flex_full_row">
                                                        <span className="flex_full_row barlowcondensed_medium elements_from_right padding_top_3 padding_right_6 ">
                                                            {formatDateTime(u.caducidad)}
                                                        </span>
                                                        <span className="flex_auto_row barlowcondensed_medium  padding_top_3 padding_right_6 nowrap">
                                                            <Timelapse
                                                                className="margin_right_6"
                                                                fontSize="small"
                                                            />
                                                            {timeDiference(
                                                                u.caducidad,
                                                                this.props.xef_reference_time,
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                    ))}
                        </Grid>
                    </div>
                </div>
            );
        };

        return (
            open && (
                <div id="xhef" className="flex_full_column boxShadow bg_ice_blue">
                    <div className="flex_auto_row barlow_semibold c_dark_grey_blue padding_top_6 padding_bottom_12 padding_left_6 padding_right_6">
                        <span className="flex_auto_row nowrap">
                            <FormattedMessage id="xhef_availables" />
                            {'  :  ' + horaventa.cadena}
                        </span>
                        <div className="flex_full_row elements_from_right">
                            <HideIcon className="hand c_bluish margin_right_32" onClick={this.handleClick} />
                            <Fab
                                onClick={() => this.props.handleOpenCommand('ready', true)}
                                color="primary"
                                size="small"
                                className="xef_add_img "
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                    <div className="flex_full_column padding_top_6 padding_bottom_12 padding_left_6 padding_right_6">
                        {groupByType
                            .map(function (item) {
                                return <Item key={randomstring()} {...item} />;
                            })}
                    </div>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}
                </div>
            )
        );
    }
}

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Available));



// WEBPACK FOOTER //
// ./src/components/complex/xhef/Available.js